<template>
  <v-card class="v-card--material-stats modern-card" v-bind="$attrs" v-on="$listeners" elevation="0">
    <v-card-text class="pa-5">
      <v-row no-gutters align="center">
        <v-col cols="auto">
          <div class="icon-wrapper" :style="{ backgroundColor: `${color}15`, color: color }">
            <v-icon :color="color" size="32">{{ icon }}</v-icon>
          </div>
        </v-col>
        <v-col class="pl-5">
          <div class="text-overline font-weight-bold mb-1 modern-title" v-text="title" />
          <h3 class="modern-value font-weight-bold mb-1" :style="{ color: '#1E293B' }" v-text="value" />
          <div class="d-flex align-center mt-2" v-if="smallValue">
            <v-icon :color="smallValueColor" size="18" class="mr-1">
              {{ smallValueIcon }}
            </v-icon>
            <span :class="[smallValueColor, 'text-caption font-weight-medium']" v-text="smallValue" />
          </div>
        </v-col>
      </v-row>
      <v-row class="mt-4" v-if="progressValue > 0">
        <v-col cols="12">
          <v-progress-linear :value="progressValue" :color="progressColor" height="6" rounded></v-progress-linear>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "MaterialStatsCard",

  props: {
    color: {
      type: String,
      default: "primary",
    },
    icon: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      default: "",
    },
    value: {
      type: [Number, String],
      default: "",
    },
    smallValue: {
      type: String,
      default: "",
    },
    smallValueIcon: {
      type: String,
      default: "mdi-arrow-up",
    },
    smallValueColor: {
      type: String,
      default: "success--text",
    },
    progressValue: {
      type: Number,
      default: 0,
    },
    progressColor: {
      type: String,
      default: "success",
    },
  },
};
</script>

<style lang="scss" scoped>
.modern-card {
  background-color: #FFFFFF !important;
  border-radius: 16px !important;
  border: 1px solid rgba(226, 232, 240, 0.8);
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03) !important;
  transition: all 0.3s ease;
  height: 100%;
  min-height: 140px;

  &:hover {
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.08), 0 4px 6px -2px rgba(0, 0, 0, 0.04) !important;
    transform: translateY(-2px);
  }

  .v-card__text {
    padding-bottom: 20px;
  }
}

.icon-wrapper {
  width: 56px;
  height: 56px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modern-title {
  font-size: 0.75rem !important;
  letter-spacing: 0.5px;
  color: #64748B !important;
  text-transform: uppercase;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.modern-value {
  font-size: 1.75rem !important;
  line-height: 1.2;
  letter-spacing: -0.5px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.v-progress-linear {
  border-radius: 4px;
}
</style>
